import React from 'react';
import moment from 'moment';
import 'moment/locale/es';

const Comment = ({ comment, user, isCaseOpen, userName }) => {
  return (
    <div className="comment-message-container">
      <div
        className={`comment-wrapper ${
          comment?.enrollmentId === user?.enrollmentId
            ? !isCaseOpen
              ? 'is-my-message message-dark'
              : 'is-my-message'
            : ''
        }`}
      >
        {comment?.enrollmentId !== user?.enrollmentId ? (
          <span className="user-text">
            {`~${comment?.anonymus ? 'Anónimo' : userName}`}
          </span>
        ) : null}
        {comment.content}
        <span
          className={`${
            comment?.enrollmentId !== user?.enrollmentId
              ? 'date-text'
              : 'date-text-is-my-message'
          }`}
        >
          {`${moment(comment.createdAt).fromNow()}`}
        </span>
      </div>
    </div>
  );
};

export default Comment;
